



















































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { User, Role, UserRole } from '@/types/Users'
import { signOut } from '@/services/auth'
import { miniNav } from '@/services/app'

@Component
export default class NavDrawer extends Vue {

  opened = false
  
  @Prop({ default: false }) value!: boolean

  @Watch('value')
  onValueChange(val: boolean) {
    this.opened = val
  }

  signOut(): void {
    signOut(this.$store)
  }

  get me(): User {
    return this.$store.getters.me
  }
  
  get mini() {
    return this.$vuetify.breakpoint.mdAndUp ? this.$store.state.app.preferences.miniNav : false
  }

  toggleMiniNav() {
    return miniNav.toggle(this.$store)
  }

  // TODO: Combine primary and secondary links

  get primaryNavLinks() {
    return this.$router.options.routes
      ?.filter((route) => {
        const meta = route.meta;

        if (!meta) return false;

        const icon = !!meta.icon;
        const restrict = !!meta.restrict;

        const userHasRequiredRole = !!meta.restrict?.some((role: UserRole) =>
          this.me?.roles?.map((r: Role) => r.id).includes(role)
        );

        return (icon && !restrict) || (icon && userHasRequiredRole);
      })
      .map((route) => ({
        text: route.name,
        icon: route.meta?.icon,
        to: route.name,
      }))
  }

  secondaryNavLinks = [
    {
      text: "Settings",
      icon: "mdi-cog",
      to: {
        name: 'settings'
      }
    },
    {
      text: 'Support',
      icon: 'mdi-help-circle-outline',
      to: {
        name: 'contact',
        params: {
          option: 'support'
        }
      }
    },
    {
      text: "Sign out",
      icon: "mdi-logout-variant",
      click: this.signOut,
      desktopOnly: true,
    },
  ]
}
